/**
 * Andys lease categories (issue #1108).
 *
 * Step 1 of the lease enquiry wizard shows CATEGORIES, not individual cars —
 * so the range scales past today's 6 leasing pages (decision on #1108).
 * Each category maps to the real `/leasing/` cars and carries a "from €X/mo"
 * (+VAT) price.
 *
 * ВАЖНО: цены — ХАРДКОД (синк с MODX вручную). Дрейфят, если на MODX меняют
 * цену страницы. Follow-up: вынести в widget-config / подтянуть в каталог.
 * priceFrom — цена машины-примера категории со страницы /leasing/, EUR/месяц,
 * БЕЗ VAT (карточка и Reserve дописывают "+VAT/mo", #1469). Сверено с
 * andys-motors.com/leasing/ 2026-10-10, когда клиент сменил примеры (#1469).
 */
// Representative car photo per category, sourced from Andys' leasing pages
// (rehosted / bundled — the live MODX images are hotlink-protected). Mapped 1:1
// to the example car of each category (#1108). WebP, not the JPEG thumbnails
// as downloaded: the widget build inlines imported images into the bundle the
// mobile homepage waits for, so photo weight is bundle weight (#1469).
import economyImg from '../../../assets/dealers/lease/economy.jpg';
import cityImg from '../../../assets/dealers/lease/city.webp';
import midSizeImg from '../../../assets/dealers/lease/mid-size.webp';
import standardImg from '../../../assets/dealers/lease/standard.webp';
import peopleCarrierImg from '../../../assets/dealers/lease/people-carrier.webp';
import sevenSeaterImg from '../../../assets/dealers/lease/seven-seater.jpg';

export const ANDYS_LEASE_CATEGORIES = [
  {
    id: 'economy',
    label: 'Economy',
    priceFrom: 250,
    examples: ['Suzuki Alto'],
    image: economyImg,
  },
  {
    id: 'city',
    label: 'City',
    priceFrom: 290,
    examples: ['Mitsubishi Mirage'],
    image: cityImg,
  },
  {
    id: 'mid-size',
    label: 'Mid-size',
    priceFrom: 345,
    examples: ['Honda Fit (new shape)'],
    image: midSizeImg,
  },
  {
    id: 'standard',
    label: 'Standard',
    priceFrom: 460,
    examples: ['Toyota Yaris Cross'],
    image: standardImg,
  },
  {
    // Была Mazda Premacy (people carrier); клиент поставил X-Trail — это SUV,
    // ярлык сменили. id прежний: он уходит в аналитику (`category`) и в CRM
    // (`leaseCategoryId`) — так ряды до и после смены остаются сравнимы.
    id: 'people-carrier',
    label: 'SUV',
    priceFrom: 500,
    examples: ['Nissan X-Trail'],
    image: peopleCarrierImg,
  },
  {
    id: 'seven-seater',
    label: '7-seater',
    priceFrom: 475,
    examples: ['Nissan Serena'],
    image: sevenSeaterImg,
  },
];

export default ANDYS_LEASE_CATEGORIES;
